import React from 'react';

interface Feature {
  icon: string;
  title: string;
  body: string;
}

const FEATURES: Feature[] = [
  {
    icon: '📡',
    title: 'Push-to-talk voice',
    body:
      'Hold the giant on-screen button and talk. Releases instantly, uploads in the background, and plays for everyone in the channel within seconds.',
  },
  {
    icon: '👥',
    title: 'Friends',
    body:
      'Add other drivers as friends with a tap. One-to-one transmissions, online presence, and a red-glow alert when an incoming voice clip is on the way.',
  },
  {
    icon: '🚛',
    title: 'Private groups',
    body:
      'Spin up a channel for your fleet, dispatcher, or weekly convoy. Members manage themselves — no admins needed.',
  },
  {
    icon: '📍',
    title: 'Nearby (5-mile)',
    body:
      'Find every other driver within five miles of you and drop into a single shared channel. No friending required.',
  },
  {
    icon: '⚡',
    title: 'Real-time presence',
    body:
      'See who is online right now. When an incoming voice clip is on the way, the whole screen pulses red so you never miss a hail.',
  },
  {
    icon: '🌙',
    title: 'Built for the cab',
    body:
      'Dark, glare-free screen tuned for night driving. Oversized touch targets. Works on the phone or tablet you already drive with.',
  },
];

export const Features: React.FC = () => {
  return (
    <section id="features">
      <div className="container">
        <span className="section-eyebrow">Features</span>
        <h2 className="section-title">Everything you need on the road.</h2>
        <p className="section-subtitle">
          One app, three ways to talk: people you know, groups you trust, and
          drivers who happen to be right next to you.
        </p>

        <div className="feature-grid">
          {FEATURES.map((f) => (
            <div className="feature-card" key={f.title}>
              <div className="feature-icon" aria-hidden="true">
                {f.icon}
              </div>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
